import React from 'react';

export default function Indicator({ category, styleIndicator, color }: { category: string, styleIndicator: any, color: string }) {
    return (
        <span className={styleIndicator} style={{ backgroundColor: color }}>{category}</span>
    );
}